<script setup>
import { ToastProvider, Toaster } from '@/components/ui/toast'
import ChatBot from '@/components/custom/ChatBot';

const config = useRuntimeConfig();
const user = useUser();
const cosmo = useCosmo();
const chatbotEnabled = computed(() => user.hasFeature('CHATBOT'));
const chatbotOpen = computed(() => chatbotEnabled.value && cosmo.isOpen);

const favicon = computed(() => {
  return config.public.isMain
    ? '/images/spotsurferLogo.png'
    : globalConfig()?.config?.site?.assets.find((a) => a.type === 'FAVICON')?.url;
});

useHead({
  htmlAttrs: {
    lang: 'en'
  },
  link: [
    {
      rel: 'icon',
      type: 'image/png',
      href: favicon
    },
    {
      rel: 'canonical',
      href: window.location
    }
  ]
});
</script>

<template>
  <NuxtLoadingIndicator />
  <ChatBot v-if="chatbotEnabled" />
  <div
    class="transition-all duration-300 ease-in-out"
    :style="{
      width: chatbotOpen ? 'calc(100vw - 400px)' : '100vw'
    }"
  >
  <NuxtLayout>
    <NuxtPage />
    <ToastProvider>
      <div class="z-999999" :class="[chatbotOpen ? 'chat-open' : '']">
        <Toaster />
      </div>
    </ToastProvider>
  </NuxtLayout>
  </div>
</template>

<style>
.chat-open ol {
  left: 0 !important;
}

@media (max-width: 767px) {
  input, select, textarea {
    font-size: 16px !important;
  }
  .text-sm {
    font-size: 16px !important;
  }
}
</style>
